import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { shortTestimonials } from '../data/testimonials';
export function TestimonialsStrip() {
  return <section className="py-12 bg-sage-light border-y border-sage" data-id="element-249" data-mp="3sq1vbv6hrw06">
      <div className="max-w-7xl mx-auto px-4" data-id="element-250" data-mp="3sseluwqbfeou">
        <div className="text-center mb-7" data-id="element-251" data-mp="3nzbpyhy2ft5h">
          <p className="text-forest font-bold tracking-widest uppercase text-sm" data-id="element-252" data-mp="3nyafaekyp8oa">
            ⭐ What Instructors Are Saying
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-253" data-mp="n0zngb71b3z">
          {shortTestimonials.map((testimonial, index) => <motion.article key={testimonial.initials} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="bg-white border border-gold/30 p-6 rounded-2xl relative shadow-sm" data-id="element-254" data-mp="fiqnzl3uq0bv" data-mpi={index}>
              <div className="flex gap-1 text-gold mb-4" aria-label="5 out of 5 stars" data-id="element-255" data-mp="ccpivtwur5ec">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" data-id="element-256" data-mp="gf40kaosbz41" data-mpi={starIndex} />)}
              </div>
              <p className="text-charcoal italic mb-6 text-sm leading-relaxed" data-id="element-257" data-mp="lbufguousonv">
                {testimonial.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-258" data-mp="q5yp5lpi7asn">
                <div className="w-10 h-10 rounded-full bg-forest/10 border border-forest flex items-center justify-center text-forest font-bold" data-id="element-259" data-mp="v2f9e4tl150g">
                  {testimonial.initials}
                </div>
                <div data-id="element-260" data-mp="144etx73t2r85">
                  <div className="font-bold text-ink text-sm" data-id="element-261" data-mp="141sk10tfzzmr">{testimonial.name}</div>
                  <div className="text-xs text-gold-dark" data-id="element-262" data-mp="1926uepiinlny">{testimonial.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}